import { memo, useCallback } from "react";

import { classNames } from "helpers";
import { Button } from "ui/components/Button/Button";
import { CheckBox } from "ui/components/CheckBox";
import { EmailTextField } from "ui/components/TextField/EmailTextField";
import { EmailRecipientsSectionProps } from "./types";


const EmailRecipientsSection: React.FC<EmailRecipientsSectionProps> = (props) => {
  const {
    formValues,
    setFormValues,
    onAddEmail,
    errors,
    onClearErrors,
  } = props;

  const { contactEmails, additionalEmails, newEmail } = formValues;

  const handleToggleContactEmail = useCallback(
    (index: number) => () => {
      setFormValues((prev) => ({
        ...prev,
        contactEmails: prev.contactEmails.map((email, i) =>
          i === index ? { ...email, selected: !email.selected } : email
        ),
      }));
    },
    [setFormValues]
  );

  const handleToggleAdditionalEmail = useCallback(
    (index: number) => () => {
      setFormValues((prev) => ({
        ...prev,
        additionalEmails: prev.additionalEmails.map((email, i) =>
          i === index ? { ...email, selected: !email.selected } : email
        ),
      }));
    },
    [setFormValues]
  );

  return (
    <div className={classNames("mb-4 border", errors.recipients ? "border-red-300" : "border-slate-200")}>
      <div className={classNames("pb-2.5 border-b px-3 pt-2.5 pb-2 text-sm font-medium transition-colors duration-200 focus:outline-none relative", errors.recipients ? "bg-red-50 border-red-300 text-red-600" : "bg-slate-50 border-slate-200 text-sky-600")}>
        Kome šaljete:
      </div>
      <div className="px-3 pt-3">
        <p className="text-sm text-gray-800 mb-3">Odaberite postojeće kontakte kojim želite poslati ponudu:</p>
      </div>
      <div className="bg-slate-50">
        {additionalEmails.map((email, index) => (
          <div key={index} className={classNames("flex items-center border-y border-slate-200 px-3 pt-2.5 pb-0.5 mb-[-1px]", (contactEmails.length + index) % 2 === 0 ? "bg-slate-50" : "bg-white")}>
            <CheckBox
              name={`additional-${index}`}
              checked={email.selected}
              onChange={handleToggleAdditionalEmail(index)}
              label={email.emailAddress}
            />
          </div>
        ))}
        {contactEmails.map((email, index) => (
          <div key={index} className={classNames("flex items-center border-y border-slate-200 px-3 pt-2.5 pb-0.5 mb-[-1px]", index % 2 === 0 ? "bg-slate-50" : "bg-white")}>
            <CheckBox
              name={`recipient-${index}`}
              checked={email.selected}
              onChange={handleToggleContactEmail(index)}
              label={
                email.description
                  ? `${email.emailAddress} (${email.description})`
                  : email.emailAddress
              }
            />
          </div>
        ))}
        {errors.recipients && (
          <p className="text-sm text-red-500 mb-2 px-3 pt-2">{errors.recipients}</p>
        )}
        <div className="px-3 py-3 bg-white">
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <EmailTextField
                name="newEmail"
                value={newEmail}
                onChange={(e: any) => {
                  setFormValues((prev) => ({ ...prev, newEmail: e.target.value }));
                  onClearErrors();
                }}
                required
                error={errors.newEmail}
                placeholder="Dodaj email adresu..."
                disableDebounce
              />
            </div>
            <Button variant="primary" onClick={onAddEmail} startIcon="/media/icons/plus.svg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(EmailRecipientsSection);
